const locations = [
  {
    name: "Elk Grove",
    addressLine1: "7405 Laguna Blvd. #170",
    addressLine2: "Elk Grove Ca, 95758",
    phoneDisplay: "916 . 647 . 9735",
    phoneTel: "+19166479735",
    hours: ["8:00am - 12:00am", "Both indoor and patio seating open"],
    orderOnlineUrl: "https://www.toasttab.com/sitlosaigon",
  },
  {
    name: "Davis",
    addressLine1: "424 G Street",
    addressLine2: "Davis, CA 95616",
    phoneDisplay: "530 . 231 . 5643",
    phoneTel: "+15302315643",
    hours: ["8:00am - 12:00am"],
    orderOnlineUrl:
      "https://www.toasttab.com/sit-lo-saigon-davis-424-g-street/v3/?mode=fulfillment",
  },
  {
    name: "Howe",
    addressLine1: "565 Howe Ave",
    addressLine2: "Sacramento, CA 95825",
    phoneDisplay: "279 . 345 . 3181",
    phoneTel: "+12793453181",
    hours: ["8:00am - 3:00pm"],
    orderOnlineUrl: "https://order.toasttab.com/online/sit-lo-saigon-howe",
  },
]

export default locations
